module.exports = __webpack_public_path__ + "media/images/front/responsive/clinic_top_page/325705/feature03-8991b3fdcb67b20f408feac901bdbd38.svg";